/** Project status values and UI helpers */

export const PROJECT_STATUS = {
  PENDING: 1,
  IN_PROGRESS: 2,
  COMPLETED: 3,
  DELETED: 4,
  MARK_AS_COMPLETED: 5,
};

export const PROJECT_STATUS_LABELS = {
  [PROJECT_STATUS.PENDING]: 'Pending',
  [PROJECT_STATUS.IN_PROGRESS]: 'In Progress',
  [PROJECT_STATUS.COMPLETED]: 'Completed',
  [PROJECT_STATUS.DELETED]: 'Deleted',
  [PROJECT_STATUS.MARK_AS_COMPLETED]: 'Mark as Completed',
};

/** All selectable statuses (excludes deleted). */
export const ALL_PROJECT_STATUS_OPTIONS = [
  { value: PROJECT_STATUS.PENDING, label: PROJECT_STATUS_LABELS[PROJECT_STATUS.PENDING] },
  { value: PROJECT_STATUS.IN_PROGRESS, label: PROJECT_STATUS_LABELS[PROJECT_STATUS.IN_PROGRESS] },
  { value: PROJECT_STATUS.MARK_AS_COMPLETED, label: PROJECT_STATUS_LABELS[PROJECT_STATUS.MARK_AS_COMPLETED] },
  { value: PROJECT_STATUS.COMPLETED, label: PROJECT_STATUS_LABELS[PROJECT_STATUS.COMPLETED] },
];

/**
 * Status options for change/edit UI.
 * Non-creators cannot set final Completed — they use "Mark as Completed" instead.
 * Creators can set Completed (and all other statuses).
 */
export function getProjectStatusOptions({ isCreator } = {}) {
  if (isCreator) {
    return ALL_PROJECT_STATUS_OPTIONS;
  }
  return ALL_PROJECT_STATUS_OPTIONS.filter(
    (option) => option.value !== PROJECT_STATUS.COMPLETED
  );
}

/**
 * Action-oriented transitions for the details-page status dropdown
 * (same interaction pattern as task details: Start / Finish / Re-open).
 * Re-open (from Completed) is creator-only.
 */
export function getProjectStatusTransitionOptions(currentStatus, { isCreator } = {}) {
  const s = Number(currentStatus);
  const options = [];

  if (s === PROJECT_STATUS.COMPLETED) {
    if (isCreator) {
      options.push({ value: PROJECT_STATUS.PENDING, label: 'Re-open' });
    }
    return options;
  }

  if (
    s === PROJECT_STATUS.PENDING ||
    s === PROJECT_STATUS.MARK_AS_COMPLETED
  ) {
    options.push({ value: PROJECT_STATUS.IN_PROGRESS, label: 'Start' });
  }

  if (s !== PROJECT_STATUS.MARK_AS_COMPLETED) {
    options.push({
      value: PROJECT_STATUS.MARK_AS_COMPLETED,
      label: 'Mark as Completed',
    });
  }

  if (isCreator) {
    options.push({ value: PROJECT_STATUS.COMPLETED, label: 'Finish' });
  }

  return options;
}

export function getProjectStatusLabel(status) {
  return PROJECT_STATUS_LABELS[status] || 'Unknown';
}

export function getProjectStatusBadgeVariant(status) {
  switch (Number(status)) {
    case PROJECT_STATUS.PENDING:
      return 'secondary';
    case PROJECT_STATUS.IN_PROGRESS:
      return 'warning';
    case PROJECT_STATUS.MARK_AS_COMPLETED:
      return 'info';
    case PROJECT_STATUS.COMPLETED:
      return 'success';
    default:
      return 'secondary';
  }
}
